import React from 'react';
import './EditorConfigButtons.less';
import classNames from 'classnames';

export interface IEditorConfigButtonsProps extends React.HTMLProps<{}> { }

const getClassName = (className?: string) => classNames('dpc-editor-config-buttons', className);

/**
 * Config button wrapper, currently just to normalize styles.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function EditorConfigButtons({ children, className }: IEditorConfigButtonsProps) {
  return <div className={getClassName(className)}>{children}</div>;
}
